import {createSlice} from "@reduxjs/toolkit";
import {groupReceiving, groupShipping} from "../../../utils/inventory";

const slice = createSlice({
    name: 'inventory',
    initialState: {
        list: [],
        shipping: [],
        receiving: [],
        pos: [],


        byId: {},


        cursor: null,
        loading: false,
        hasMore: true,
        initialized: false,

        error: null,
    },
    reducers: {
        startLoading: (state) => {
            state.initialized = true;
            state.loading = true;
            state.error = null;
        },
        hasError: (state, action) => {
            state.loading = false;
            state.error = action.payload;
            console.error(action.payload)
        },
        gotCartForPurchase: (state, action) => {
            state.loading = false;
            state.error = null;
            state.list = action.payload.list;
            state.cursor = action.payload.cursor;
            state.hasMore = action.payload.hasMore;
        },
        gotInventory: (state, action) => {
            state.loading = false;
            state.error = null;
            state.list = action.payload.list;
            state.cursor = action.payload.cursor;
            state.hasMore = action.payload.hasMore;
        },
        gotShipping: (state, action) => {
            state.loading = false;
            state.error = null;
            state.shipping = groupShipping(action.payload);
        },
        gotReceiving: (state, action) => {
            state.loading = false;
            state.error = null;
            state.receiving = groupReceiving(action.payload);
        },
        gotPos: (state, action) => {
            state.loading = false;
            state.error = null;
            state.pos = action.payload
        },
        registerItems: (state, action) => {
            state.byId = {...state.byId, ...action.payload}
        },

    },

    // extraReducers: builder => { 
    //     builder.addMatcher(action => action.type.endsWith('inventory'), state => {
    //         console.log(state)
    //         console.log(state)
    //     })
    // }
})

export const {startLoading, gotInventory, hasError, gotShipping, gotReceiving, gotPos, registerItems, gotCartForPurchase} = slice.actions

const inventoryReducer = slice.reducer;

export default inventoryReducer